/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from 'services/api';

import { PUBLISHER_FILE_UPLOAD_URL, PUBLISHERS_URL } from './constants';
import {
  CreateUpdatePublisherRequest,
  MembersPagingRequestValue,
  MembersPagingResponse,
} from './publisherApiTypes';

const getPublishers = (payload: MembersPagingRequestValue) => {
  return api.get<MembersPagingResponse>(
    `${PUBLISHERS_URL}?page=${payload.page}&size=${payload.size}&includeMappings=true`,
  );
};

const createPublisher = (payload: CreateUpdatePublisherRequest) => {
  const formData = new FormData();

  if (payload.id !== null && payload.id !== undefined) {
    formData.append('id', payload.id.toString());
  }
  formData.append('name', payload.displayName);
  formData.append('displayName', payload.displayName);
  formData.append('icon', payload.icon);

  // Add mapping arrays (always send them, even if empty)
  const dealIds = payload.dealIds || [];
  const siteDomains = payload.siteDomains || [];
  const appIds = payload.appIds || [];

  if (dealIds.length === 0) {
    formData.append('dealIds', '');
  } else {
    dealIds.forEach((dealId) => formData.append('dealIds', dealId));
  }

  if (siteDomains.length === 0) {
    formData.append('siteDomains', '');
  } else {
    siteDomains.forEach((domain) => formData.append('siteDomains', domain));
  }

  if (appIds.length === 0) {
    formData.append('appIds', '');
  } else {
    appIds.forEach((appId) => formData.append('appIds', appId));
  }

  return api.post(PUBLISHERS_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const updatePublisher = (payload: CreateUpdatePublisherRequest) => {
  const formData = new FormData();

  if (payload.id) {
    formData.append('id', payload.id.toString());
  }
  formData.append('name', payload.displayName);
  formData.append('displayName', payload.displayName);

  // Only append icon if it's a file object (new upload) or explicitly null (removal)
  if (payload.icon && typeof payload.icon === 'object') {
    formData.append('icon', payload.icon);
  } else if (payload.icon === null) {
    // Send an empty blob to indicate removal
    formData.append('icon', new Blob(), '');
  }

  // Only add mapping arrays if they are explicitly provided
  // undefined/null = don't update, empty array = clear all, array with values = update
  if (payload.dealIds !== undefined && payload.dealIds !== null) {
    if (payload.dealIds.length === 0) {
      // Append empty value to indicate we want to clear the array
      formData.append('dealIds', '');
    } else {
      payload.dealIds.forEach((dealId) => formData.append('dealIds', dealId));
    }
  }
  if (payload.siteDomains !== undefined && payload.siteDomains !== null) {
    if (payload.siteDomains.length === 0) {
      formData.append('siteDomains', '');
    } else {
      payload.siteDomains.forEach((domain) => formData.append('siteDomains', domain));
    }
  }
  if (payload.appIds !== undefined && payload.appIds !== null) {
    if (payload.appIds.length === 0) {
      formData.append('appIds', '');
    } else {
      payload.appIds.forEach((appId) => formData.append('appIds', appId));
    }
  }

  return api.put(PUBLISHERS_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deletePublisher = (action: string) => {
  return api.delete(`${PUBLISHERS_URL}/${action}`);
};

const uploadPublisherFile = (payload: any) => {
  const formData = new FormData();

  formData.append('file', payload?.file);

  return api.post(PUBLISHER_FILE_UPLOAD_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const publisherApi = {
  getPublishers,
  createPublisher,
  updatePublisher,
  deletePublisher,
  uploadPublisherFile,
};
